import { PropertyTypeDTO } from "../DTO/propertyTypeDTO";
import { PropertySubType } from "./propertySubType";

export class PropertyType{
    
    public id!:number;
    public name!:string;
    public subTypeList:PropertySubType[]=[];
    public subTypeIdList:number[]=[];
    
    constructor(){
        this.subTypeList=new Array<PropertySubType>();
    }

    public static mapToDTO(param:PropertyType) : PropertyTypeDTO{
        
        let dto = new PropertyTypeDTO();
        try
        {
            dto.id = param.id;
            dto.name = param.name;
            if(param.subTypeList) dto.subTypeList = param.subTypeList.map(st=>PropertySubType.mapToDTO(st));
        }
        catch(e)
        {
            console.log(e);
        }
        return dto;
    }
    public static mapFromDTO(param:PropertyTypeDTO) : PropertyType
    {
        
        let obj = new PropertyType();
        try
        {
            obj.id = param.id;
            obj.name = param.name;
            if(param.subTypeList) obj.subTypeList = param.subTypeList.map(st=>PropertySubType.mapFromDTO(st));
        }
        catch(e)
        {
            console.log(e);
        }
        return obj;
    }

}